export const EmailIcon = ({ color = '#14181F' }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 14C6 11.7909 7.79086 10 10 10H38C40.2091 10 42 11.7909 42 14V34C42 36.2091 40.2091 38 38 38H10C7.79086 38 6 36.2091 6 34V14Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42 14L24 26L6 14"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CakeIcon = ({ color = '#9C56E0' }) => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 17.448V12.948"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 12.948C32.6625 9.948 24 2.448 24 2.448C24 2.448 15 9.948 24 12.948Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.375 24.573C30.375 26.2638 29.7033 27.8853 28.5078 29.0808C27.3123 30.2763 25.6908 30.948 24 30.948C22.3092 30.948 20.6877 30.2763 19.4922 29.0808C18.2966 27.8853 17.625 26.2638 17.625 24.573"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.625 24.573C17.6254 26.2413 16.9718 27.8432 15.8045 29.0351C14.6372 30.2269 13.0492 30.9137 11.3813 30.948C7.80004 31.023 4.87504 28.023 4.87504 24.4418V21.948C4.87256 21.3564 4.98726 20.7701 5.21253 20.223C5.4378 19.6759 5.76917 19.1789 6.18753 18.7605C6.60589 18.3422 7.10295 18.0108 7.65003 17.7855C8.19712 17.5603 8.7834 17.4456 9.37504 17.448H38.625C39.2167 17.4456 39.803 17.5603 40.35 17.7855C40.8971 18.0108 41.3942 18.3422 41.8126 18.7605C42.2309 19.1789 42.5623 19.6759 42.7876 20.223C43.0128 20.7701 43.1275 21.3564 43.125 21.948V24.4418C43.125 28.023 40.2 31.023 36.6188 30.948C34.9509 30.9137 33.3629 30.2269 32.1956 29.0351C31.0283 27.8432 30.3747 26.2413 30.375 24.573"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5 29.6918V39.948C40.5 40.3458 40.342 40.7274 40.0607 41.0087C39.7794 41.29 39.3978 41.448 39 41.448H9C8.60218 41.448 8.22064 41.29 7.93934 41.0087C7.65804 40.7274 7.5 40.3458 7.5 39.948V29.6918"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarIcon = ({ color = '#9C56E0' }) => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39 8.448H9C8.17157 8.448 7.5 9.11957 7.5 9.948V39.948C7.5 40.7764 8.17157 41.448 9 41.448H39C39.8284 41.448 40.5 40.7764 40.5 39.948V9.948C40.5 9.11957 39.8284 8.448 39 8.448Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 5.448V11.448"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5.448V11.448"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 17.448H40.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.75 24.948L21.9938 33.198L17.25 28.698"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThumbsUpIcon = ({ color = '#9C56E0' }) => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 20.448H15V39.948H6C5.60218 39.948 5.22064 39.79 4.93934 39.5087C4.65804 39.2274 4.5 38.8458 4.5 38.448V21.948C4.5 21.5502 4.65804 21.1686 4.93934 20.8873C5.22064 20.606 5.60218 20.448 6 20.448V20.448Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 20.448L22.5 5.448C24.0913 5.448 25.6174 6.08014 26.7426 7.20536C27.8679 8.33058 28.5 9.8567 28.5 11.448V15.948H40.1062C40.5316 15.9469 40.9523 16.0369 41.34 16.2119C41.7277 16.3869 42.0735 16.6429 42.3541 16.9625C42.6348 17.2822 42.8437 17.6583 42.967 18.0654C43.0902 18.4725 43.1249 18.9013 43.0687 19.323L40.8187 37.323C40.7277 38.0456 40.3769 38.7104 39.8318 39.1934C39.2867 39.6764 38.5845 39.9446 37.8562 39.948H15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WhatsAppIcon = () => {
  return (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32.052" r="32" fill="#25D366" />
      <g filter="url(#filter0_d_1103_21542)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4479 45.0248L24.0199 45.3638C26.4231 46.79 29.1784 47.5443 31.9883 47.5459H31.9944C40.6233 47.5459 47.6463 40.5244 47.65 31.8949C47.6513 27.7127 46.0246 23.7803 43.0687 20.8222C40.1127 17.8643 36.1823 16.2341 32.0004 16.2323C23.3646 16.2323 16.3418 23.2528 16.3384 31.8821C16.3372 34.8393 17.1645 37.7191 18.7318 40.211L19.1044 40.8033L17.5224 46.5784L23.4479 45.0248ZM13 51.052L15.6722 41.2948C14.024 38.4391 13.1569 35.1996 13.1582 31.881C13.1622 21.4987 21.6116 13.052 31.9944 13.052C37.0329 13.0541 41.762 15.0151 45.3185 18.5741C48.8745 22.1333 50.8322 26.8645 50.8305 31.8961C50.8261 42.2777 42.3753 50.726 31.9944 50.726C31.9937 50.726 31.9948 50.726 31.9944 50.726H31.9864C28.834 50.7247 25.7365 49.9342 22.9854 48.4336L13 51.052Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.2892 24.0119C26.9365 23.2282 26.5655 23.2125 26.2301 23.1987C25.9557 23.187 25.6417 23.1878 25.3282 23.1878C25.0142 23.1878 24.5044 23.3055 24.0732 23.7765C23.6417 24.2475 22.4258 25.3861 22.4258 27.7016C22.4258 30.0173 24.1125 32.2549 24.3475 32.5692C24.5829 32.8829 27.6035 37.7867 32.3872 39.6732C36.363 41.241 37.1721 40.9291 38.0349 40.8506C38.8978 40.7723 40.8196 39.7125 41.2116 38.6134C41.6039 37.5146 41.6039 36.5726 41.4863 36.3759C41.3687 36.1797 41.0548 36.0619 40.5842 35.8267C40.1133 35.5913 37.7995 34.4526 37.3682 34.2955C36.9367 34.1387 36.6229 34.0603 36.309 34.5315C35.9952 35.0021 35.0938 36.0619 34.8192 36.3759C34.5447 36.6904 34.27 36.7296 33.7994 36.4942C33.3286 36.2581 31.8128 35.7616 30.0146 34.1584C28.6154 32.9109 27.6709 31.3703 27.3962 30.8992C27.1218 30.4285 27.3669 30.1736 27.6029 29.939C27.8144 29.7281 28.0737 29.3894 28.3091 29.1148C28.5439 28.8399 28.6223 28.6438 28.7792 28.3298C28.9362 28.0157 28.8577 27.7409 28.7401 27.5054C28.6223 27.27 27.7077 24.9426 27.2892 24.0119Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1103_21542"
          x="9"
          y="10.052"
          width="45.8306"
          height="46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1103_21542"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1103_21542"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const FacebookIcon = ({ color = '#FFFFFF' }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.669434 14.0546C0.670985 20.6138 5.44064 26.1987 11.9188 27.2267V17.908H8.5361V14.0546H11.9228V11.1213C11.7714 9.73137 12.2461 8.3461 13.2183 7.34122C14.1904 6.33634 15.5592 5.816 16.9534 5.92131C17.9541 5.93747 18.9524 6.0266 19.9401 6.18798V9.46665H18.2548C17.6746 9.39065 17.0912 9.58228 16.6691 9.98754C16.247 10.3928 16.0318 10.9678 16.0841 11.5506V14.0546H19.7788L19.1881 17.9093H16.0841V27.2267C23.0901 26.1194 28.0029 19.721 27.2634 12.6667C26.524 5.61247 20.3912 0.371885 13.3079 0.741551C6.22458 1.11122 0.67056 6.96172 0.669434 14.0546Z"
        fill={color}
      />
    </svg>
  );
};

export const InstagramIcon = ({ color = '#FFFFFF' }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0024 24.1067C8.72244 24.1067 8.33578 24.0894 7.05577 24.0334C6.0576 24.0006 5.07235 23.7976 4.14244 23.4334C2.53352 22.8073 1.2613 21.5345 0.635775 19.9254C0.285516 18.9921 0.0965986 18.006 0.0771081 17.0094C0.00244141 15.732 0.00244141 15.3134 0.00244141 12.0587C0.00244141 8.76938 0.0197747 8.38538 0.0771081 7.11205C0.0970249 6.11674 0.285936 5.13206 0.635775 4.20005C1.26062 2.58876 2.53491 1.31495 4.14644 0.690716C5.07797 0.338986 6.0629 0.149575 7.05844 0.130716C8.33178 0.0587158 8.75044 0.0587158 12.0024 0.0587158C15.3091 0.0587158 15.6891 0.0760492 16.9491 0.130716C17.9472 0.149738 18.9348 0.339129 19.8691 0.690716C21.4802 1.31565 22.7542 2.58922 23.3798 4.20005C23.7359 5.14564 23.9259 6.14572 23.9411 7.15605C24.0158 8.43338 24.0158 8.85072 24.0158 12.104C24.0158 15.3574 23.9971 15.784 23.9411 17.0467C23.9213 18.0443 23.7319 19.0313 23.3811 19.9654C22.754 21.5757 21.4799 22.8488 19.8691 23.4747C18.9361 23.8243 17.9506 24.0132 16.9544 24.0334C15.6811 24.1067 15.2638 24.1067 12.0024 24.1067ZM11.9571 2.16938C8.69578 2.16938 8.35711 2.18538 7.08378 2.24272C6.32375 2.25278 5.57108 2.39304 4.85844 2.65738C3.80611 3.06006 2.97341 3.88937 2.56644 4.94005C2.30006 5.66045 2.15979 6.42135 2.15177 7.18938C2.08111 8.48138 2.08111 8.82005 2.08111 12.0587C2.08111 15.2587 2.09311 15.6467 2.15177 16.9307C2.16371 17.691 2.3039 18.4438 2.56644 19.1574C2.97401 20.2074 3.80657 21.0361 4.85844 21.4387C5.57059 21.7048 6.32358 21.8451 7.08378 21.8534C8.37444 21.9281 8.71444 21.9281 11.9571 21.9281C15.2278 21.9281 15.5664 21.9121 16.8291 21.8534C17.5896 21.8441 18.3429 21.7039 19.0558 21.4387C20.1017 21.0326 20.929 20.2058 21.3358 19.16C21.6016 18.439 21.7419 17.6778 21.7504 16.9094H21.7651C21.8224 15.6347 21.8224 15.2947 21.8224 12.0374C21.8224 8.78005 21.8078 8.43738 21.7504 7.16405C21.7385 6.40465 21.5983 5.65273 21.3358 4.94005C20.9299 3.89281 20.1025 3.06444 19.0558 2.65738C18.343 2.3917 17.5897 2.25141 16.8291 2.24272C15.5398 2.16938 15.2024 2.16938 11.9571 2.16938ZM12.0024 18.2174C9.50909 18.219 7.26033 16.7184 6.30492 14.4153C5.34952 12.1123 5.87565 9.46049 7.63795 7.69666C9.40025 5.93284 12.0516 5.40441 14.3555 6.35783C16.6593 7.31124 18.1619 9.5587 18.1624 12.052C18.1588 15.4535 15.4039 18.2108 12.0024 18.2174ZM12.0024 8.04938C9.7933 8.04938 8.00244 9.84024 8.00244 12.0494C8.00244 14.2585 9.7933 16.0494 12.0024 16.0494C14.2116 16.0494 16.0024 14.2585 16.0024 12.0494C15.9973 9.84237 14.2095 8.05451 12.0024 8.04938ZM18.4024 7.09872C17.6097 7.09577 16.969 6.4515 16.9704 5.65873C16.9719 4.86595 17.615 4.22406 18.4078 4.22406C19.2005 4.22406 19.8436 4.86594 19.8451 5.65872C19.8455 6.0412 19.6935 6.40808 19.4228 6.67829C19.1521 6.94849 18.7849 7.09978 18.4024 7.09872Z"
        fill={color}
      />
    </svg>
  );
};

export const LinkedinIcon = ({ color = '#FFFFFF' }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 24.052H8V8.052H13.3333V10.7187C14.4702 9.27234 16.1942 8.4101 18.0333 8.368C21.3408 8.38636 24.0096 11.0778 24 14.3853V24.052H18.6667V15.052C18.4534 13.5622 17.1757 12.4568 15.6707 12.46C15.0124 12.4808 14.391 12.769 13.9499 13.2582C13.5088 13.7473 13.2862 14.3951 13.3333 15.052V24.052ZM5.33333 24.052H0V8.052H5.33333V24.052ZM2.66667 5.38534C1.19391 5.38534 0 4.19143 0 2.71867C0 1.24591 1.19391 0.052002 2.66667 0.052002C4.13943 0.052002 5.33333 1.24591 5.33333 2.71867C5.33333 3.42591 5.05238 4.10419 4.55229 4.60429C4.05219 5.10438 3.37391 5.38534 2.66667 5.38534Z"
        fill={color}
      />
    </svg>
  );
};

export const ArrowDownIcon = ({ color = '#FFFFFF' }) => {
  return (
    <svg
      width="22"
      height="13"
      viewBox="0 0 22 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.09231 3.21164C0.491198 2.61776 0.491198 1.6472 1.09231 1.05332C1.68322 0.469535 2.63373 0.469535 3.22463 1.05332L11 8.73504L18.7754 1.05332C19.3663 0.469535 20.3168 0.469535 20.9077 1.05332C21.5088 1.6472 21.5088 2.61776 20.9077 3.21164L11 13L1.09231 3.21164Z"
        fill={color}
      />
    </svg>
  );
};
